import React, { FC } from 'react'

import { LicensingFramework } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface LicensingFrameworkFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const LicensingFrameworkFilter: FC<LicensingFrameworkFilterProps> = props => {
  const licensingFrameworkOptions = Object.keys(LicensingFramework).map(framework => {
    const value = LicensingFramework[framework as keyof typeof LicensingFramework]
    return {
      value,
      label: capitalizeEachFirstLetter(value.replace(/_/g, ' ')),
    }
  })

  return (
    <CheckboxBasedFilter
      title="Licensing Framework"
      options={licensingFrameworkOptions}
      {...props}
    />
  )
}
